import type { App } from 'utils/app/types';

/**
 * Returns a function that determines if an event is not one of an array of types.
 */
export function isNotOneOf(eventTypes: string[]) {
  const eventTypesSet = new Set(Array.isArray(eventTypes) ? eventTypes : Object.values(eventTypes));

  return function isType(event: App.Event): boolean {
    return !eventTypesSet.has(event.type);
  };
}
